import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-property-list',
  templateUrl: './property-list.component.html',
  styleUrls: ['./property-list.component.less']
})
export class PropertyListComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    this.propertySvc.properties = [];
  }
  @Input()
  public clientId: number;

  @Input()
  public craCheck: boolean;


public get clientLocations() : Array<ClientLocation> {
  if(!this.propertySvc.properties) return [];
  return this.propertySvc.properties;
}


  constructor(private propertySvc : PropertyService, private auth : AuthService, private location : Router) { }

  ngOnInit() {
    if(this.craCheck)
      this.propertySvc.FetchPropertyList(this.propertySvc.propertyFilter);
    else
      this.propertySvc.FetchPropertiesForClient(this.clientId);
  }

  viewProperty(prop : ClientLocation) {
    this.location.navigateByUrl(`properties/stats/${prop.id}/${prop.clientId}`);
  }

}
